import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import RecordsPanel from "@/pages/hr/attendance/RecordsPanel";
import ExceptionsPanel from "@/pages/hr/attendance/ExceptionsPanel";
import LocationsPanel from "@/pages/hr/attendance/LocationsPanel";
import NetworksPanel from "@/pages/hr/attendance/NetworksPanel";
import PoliciesPanel from "@/pages/hr/attendance/PoliciesPanel";
import QrPanel from "@/pages/hr/attendance/QrPanel";
import ReadinessPanel from "@/pages/hr/attendance/ReadinessPanel";
import FaceVerificationPanel from "@/pages/hr/attendance/FaceVerificationPanel";

export default function AttendanceTab() {
  const { can } = useAuth();
  const subtabs = [
    { id: "records", label: "Records", show: true, el: <RecordsPanel /> },
    { id: "exceptions", label: "Exceptions", show: can("attendance:exception_review"), el: <ExceptionsPanel /> },
    { id: "locations", label: "Locations", show: can("attendance:location_manage"), el: <LocationsPanel /> },
    { id: "networks", label: "Networks", show: can("attendance:policy_manage"), el: <NetworksPanel /> },
    { id: "policies", label: "Policies", show: can("attendance:policy_manage"), el: <PoliciesPanel /> },
    { id: "qr", label: "QR Verification", show: can("attendance:qr_manage"), el: <QrPanel /> },
    { id: "face", label: "Face Verification", show: can("attendance:face_manage"), el: <FaceVerificationPanel /> },
    { id: "readiness", label: "Go-Live Readiness", show: can("attendance:view_all") || can("attendance:policy_manage") || can("attendance:view_team"), el: <ReadinessPanel /> },
  ].filter(t => t.show);
  const [sub, setSub] = useState(subtabs[0]?.id);

  return (
    <div data-testid="hr-attendance-tab">
      <div className="flex gap-1 mb-4 flex-wrap">
        {subtabs.map(t => (
          <button key={t.id} data-testid={`att-subtab-${t.id}`} onClick={() => setSub(t.id)}
            className={`px-3 py-1.5 text-sm font-medium rounded-full border ${sub === t.id ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-500 border-slate-200 hover:text-slate-700"}`}>{t.label}</button>
        ))}
      </div>
      {subtabs.find(t => t.id === sub)?.el}
    </div>
  );
}
